import React, { useEffect, useState } from "react";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import { useForm } from "react-hook-form";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Badge, Form, Modal, ModalBody, ModalHeader } from "reactstrap";

import {
  createQualification,
  deleteQualification,
  listQualificationAPI,
  updateQualification,
} from "../../api/master/indes";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { toast } from "react-toastify";
import OrderComponent from "../../MyComp/UI/form/OrderComponent";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import useLogout from "../../hooks/useLogout";

const Qualifications = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm();

  const { logout } = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setShowDeleteModal(true);
  };
  const [modalOpen, setModalOpen] = useState(false);

  const handleActionClick = (row) => {
    setSelectedRow(row);
    setModalOpen(true);
  };

  const columns = [
    {
      name: "Qualification",
      selector: (row) => row?.qualification,
      sortable: true,
    },
    {
      name: "Order",
      selector: (row) => row?.order,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status.Label,
      cell: (row) => (
        <Badge
          color={row.status ? "success" : "danger"} 
          onClick={() => handleToggleStatus(row)}
        >
          {row.status ? "Active" : "InActive"}
        </Badge>
      ),
      sortable: true,
      width:"90px"
    },
    {
      name: "Action",
      width:"120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>
          <Button outline color="danger" size="xs" className="me-1" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" />
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getQualificationList();
  }, []);

  const getQualificationList = () => {
    setIsLoading(true);
    listQualificationAPI()
      .then((res) => {
        if (res.data.status === true) {
          const formattedData = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
                ...item,
                status: item.status === 1 || item.status === true,
              }))
            : [];
          setData(formattedData);
        } else if (res.data.status === "expired") {
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setIsLoading(false));
  };

  const onFormSubmit = (formValues) => {
    const bodyData = {
      qualification: formValues?.qualification,
      order: Number(formValues?.order),
      status: formValues?.status?.value,
      ...(mode === "Edit" && { id: selectedRow?.id }),
    };

    setIsLoading(true);

    const apiCall = mode === "Add" ? createQualification(bodyData) : updateQualification(bodyData);

    apiCall
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          getQualificationList();
          setIsOpen(false);
          reset();
        } else if (res.data.status === "expired") {
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setIsLoading(false));
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setMode("Edit");
    setIsOpen(true);
    setSelectedRow(row);

    setValue("qualification", row.qualification);
    setValue("order", row.order);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  const confirmStatusChange = () => {
    const newStatus = !selectedRow.status;
    updateQualification({ id: selectedRow.id, status: newStatus })
      .then((res) => {
        if (res.data.status) {
          toast.success("Status updated!");
          setData((prev) => prev.map((item) => (item.id === selectedRow.id ? { ...item, status: newStatus } : item)));
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setShowModal(false));
  };

  const confirmDelete = () => {
    if (!selectedRow) return;

    // setLoading(true);

    deleteQualification({ id: selectedRow.id })
      .then((res) => {
        // setLoading(false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          setData((prev) => prev.filter((item) => item.id !== selectedRow.id));
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  return (
    <>
      <Head title="Qualification | Master" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Qualification
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                onClick={() => {
                  setIsOpen((prev) => !prev);
                  setMode("Add");
                  reset();
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Qualification"
                      name="qualification"
                      placeholder="Enter qualification"
                      required
                    />
                  </Col>
                  <Col md="4">
                    <OrderComponent
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Order"
                      name="order"
                      placeholder="Enter order"
                      required
                    />
                  </Col>
                  <Col md="4">
                    <Status register={register} watch={watch} title={"Status"} setValue={setValue} trigger={trigger} errors={errors} />
                  </Col>
                </Row>
                <Col md="2" className="">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable
            data={Array.isArray(data) ? data : []}
            columns={columns}
            title="Qualification List"
            isLoading={isLoading}
          />
        </Block>
      </Content>

      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal} // ✅ FIXED — pass the setter function
        confirmDelete={confirmDelete}
        selectedRow={selectedRow}
        // loading={loading}
      />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
    </>
  );
};

export default Qualifications;
